import React, { Component } from 'react'
import Utils from '../../lib/utils'
const styles = require('./index.module.less')

export default class TitleContent extends Component {
    static defaultProps = {
      mainTitleLinks: [],
      subRightLinkInfo: [],
      tabType: '',
      moduleId: ''
    }

    constructor (props) {
      super(props)
      this.newMainTitleLinks = this.recomMainTitle(props.mainTitleLinks)
    }

    /**
     * 双主标题处理 多个主标题使用 • 隔开
     * @param {Array} mainTitleLinks
     */
    recomMainTitle (mainTitleLinks) {
      if (mainTitleLinks.length < 2) {
        return mainTitleLinks
      }

      const newMainTitle = []
      mainTitleLinks.map((title, index) => {
        newMainTitle.push(title)
        if (index < mainTitleLinks.length - 1) {
          newMainTitle.push({ isCut: 'true', title: '•' })
        }
      })
      return newMainTitle
    }

    shouldComponentUpdate (nextProps, nextState) {
      return false
    }

    render () {
      if ((this.newMainTitleLinks.length === 0 && !this.props.subRightLinkInfo) || this.props.tabType === 'TIME') {
        return ''
      }

      return (
        <h2 className={styles.module_title}>
          {
            this.newMainTitleLinks.map((mainTitle, index) => {
              if (!mainTitle) {
                return ''
              }
              if (mainTitle.isCut) {
                return <span
                  className={styles.main_title_cut}
                  key={index}>{mainTitle.title}</span>
              } else {
                return mainTitle.link
                  ? <a key={index}
                    {...Utils.getItemSpmData(mainTitle, true)}
                    {...Utils.getATagProps(mainTitle)}
                    className={styles.main_title}> {mainTitle.title} </a>
                  : <span
                    key={index}
                    className={styles.main_title}> {mainTitle.title} </span>
              }
            })
          }

          {
            this.props.subRightLinkInfo
              ? <a className={styles.right_content}
                {...Utils.getItemSpmData(this.props.subRightLinkInfo, true)}
                {...Utils.getATagProps(this.props.subRightLinkInfo)}>{ this.props.subRightLinkInfo.subRightLinkTitle}</a>
              : ''}
        </h2>
      )
    }
}
